(function($) {

    // variables
    // cached elements
    var $html = $('html');
    var $root = $('html, body');
    var $navItemWithSubnav = $('#nav-main>ul>li.menu-item-has-children');
    // classnames set by JS
    var $navVisibleClass = 'nav-is-visible'
    var $subNavItemVisibleClass = 'this-menu-item-is-visible'
    var $downloadcenterVisibleClass = 'downloadcenter-is-visible'

    // load foundation-functions
    //$(document).foundation();

    // for toggling mobile-navigation via hamburger
    $('.js-show-nav').on('click', function(e) {
        e.preventDefault();
        $html.toggleClass($navVisibleClass);
    });
    // for showing download-center
    $('.js-show-downloadcenter').on('click', function(e) {
        e.preventDefault();
        $html.addClass($downloadcenterVisibleClass);
    });
    // for hiding download-center
    $('.js-hide-downloadcenter').on('click', function(e) {
        e.preventDefault();
        $html.removeClass($downloadcenterVisibleClass);
    });
    // for hiding download-center on overlay-click
    $('.overlay-content').mouseup(function (e) {
        var container = $(this).find(".ns-title-h1, .ns-title-h2, .ns-table");
        // if the target of the click isn't the container nor a descendant of the container, hide downloadcenter
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $html.removeClass($downloadcenterVisibleClass);
        }
    });

    // add class to all nav-items with subnav
    // add event listeners for submenu-click
    var createSubnavControls = function() {
        // make subnav toggle on tap / click
        $navItemWithSubnav
            .off('click')
            .on('click', '>a', function(e){
                e.preventDefault();
                $(this).parent()
                    .toggleClass($subNavItemVisibleClass)
                    .siblings()
                    .removeClass($subNavItemVisibleClass);
            });
    }
    createSubnavControls();

    // hide nav and downloadcenter on ESC if visible
    $(document).on('keydown', function(e) {
        if (e.keyCode == 27) {
            if ( $html.hasClass($downloadcenterVisibleClass) && $html.hasClass($navVisibleClass) ) {
                $html.removeClass($downloadcenterVisibleClass);
            }
            else if ( $html.hasClass($navVisibleClass) ) {
                $html.removeClass($navVisibleClass);
            }
            else if ( $html.hasClass($downloadcenterVisibleClass) ) {
                $html.removeClass($downloadcenterVisibleClass);
            }
        }
    });
    $('.content-wrap, .head-stage-2').click(function() {
        if ( $html.hasClass($navVisibleClass) ) {
           $html.removeClass($navVisibleClass);
       }
    });

    // animate anchor-link: go top
    jQuery.extend( jQuery.easing, {
        easeInOutCubic: function (x, t, b, c, d) {
            if ((t/=d/2) < 1) return c/2*t*t*t + b;
            return c/2*((t-=2)*t*t + 2) + b;
        }
    });
    $("a[href^='#top']").click(function (e) {
        $root.animate({
            scrollTop: 0
        }, 400, 'easeInOutCubic');
    });
})( jQuery );
